import { CheckCircle2 } from "lucide-react";
import InventoryTable from "../components/InventoryTable";

export default function FinishedGoods() {
  return (
    <InventoryTable section="finished_goods" icon={CheckCircle2} title="Finished Goods" />
  );
}
